export default "__VITE_ASSET__8DQ$Nc2e__";